<template>
    <!-- ////////// STRUCTURE: array to add in front ////////////// -->
    <!--  ++ column sum have to be 11 -->
    <!-- ** one line : simple one -->
    <!-- AuditCardCols: Array<any> = [
        {
            cols: 11,
            component: "h3",
            props: {
                class: "text-primary",
            },
            content: "Titre de la section",
        }
    ] -->

    <!-- ** multiples rows with nested cols-->
    <!-- AuditCardCols: Array<any> = [
        {
            cols: 11,
            nestedRows: [
                {
                    nestedCols: [
                        objectCol,
                        objectCol
                    ],
                },
                {
                    nestedCols: [
                        objectCol
                    ],
                },
            ],
        },
    ]; -->

    <!-- ++ objectCol exemples -->
    <!-- ** h3 color primary -->
    <!-- {
        cols: 7,
        component: "h3",
        props: {
            class: "text-primary",
        },
        amount: null,
        content: "Titre de la section",
    }, -->

    <!-- ** if amount is not null > content = null -->

    <!-- ** v-tooltip - simple text -->
    <!-- {
        cols: 1,
        component: "v-tooltip",
        props: { color: "red"},
        amount: null,
        content: "Texte d'aide",
    }, -->

    <!-- ** v-tooltip - html -->
    <!-- {
        cols: 1,
        component: "v-tooltip",
        props: { color: "red"},
        amount: null,
        textHtml: "<p>Texte d'aide</p>",
    }, -->

    <!-- ++ col.props -->
    <!-- ** send only colors or justify-end || justify-center -->
    <!-- class: "text-primary" for text color -->
    <!-- color: "red" for tooltip, icon, btn -->

    <!-- ++ AuditCardCols is set in contructor -->
    <!--  ** add a Watch on amounts to send -->
    <!-- @Watch('totalBalance411NL')
    onTotalBalance411NLChanged() {
        this.cardCols411[1].nestedRows[0].nestedCols[1].content = this.totalBalance411NL || 0;
    } -->

    <!-- //////////////////////////////////////////////////////// -->

    <v-card class="my-2">
        <v-row no-gutters class="px-6">
            <!-- ++ 11 columns -->
            <v-col
                v-for="(col, colIndex) in cardCols"
                :key="`col-${colIndex}`"
                :cols="col.cols"
                style="align-content: center"
                :class="dynamicClass(cardCols, false, 1, 1, col)"
            >
                <!-- ++ col.nestedRows -->
                <template v-if="col.nestedRows">
                    <div v-for="(nestedRow, rowIndex) in col.nestedRows" :key="`row-${rowIndex}`">
                        <v-row no-gutters>
                            <v-col
                                v-for="(nestedCol, nestedColIndex) in nestedRow.nestedCols"
                                :key="`nestedCol-${nestedColIndex}`"
                                :cols="nestedCol.cols"
                                style="align-content: center"
                                :class="
                                    dynamicClass(
                                        nestedRow.nestedCols,
                                        true,
                                        rowIndex,
                                        col.nestedRows.length,
                                        nestedCol,
                                    )
                                "
                            >
                                <template v-if="nestedCol.component === 'v-tooltip'">
                                    <v-tooltip location="bottom" v-bind="nestedCol.props">
                                        <template v-slot:activator="{ props }">
                                            <v-btn-icon
                                                v-bind="props"
                                                size="large"
                                                class="ml-2"
                                                icon="$oss-help"
                                                :color="nestedCol.props.color || undefined"
                                            />
                                        </template>

                                        <AuditCardCols :col="nestedCol" />
                                    </v-tooltip>
                                </template>

                                <component
                                    v-else
                                    :is="nestedCol.component"
                                    v-bind="nestedCol.props"
                                >
                                    <!-- v-bind="nestedCol.props" -->
                                    <AuditCardCols :col="nestedCol" />
                                </component>
                            </v-col>
                        </v-row>
                    </div>
                </template>

                <!-- ++ no col.nestedRows -->
                <component v-else :is="col.component" v-bind="col.props">
                    <AuditCardCols :col="col" />
                </component>
            </v-col>

            <!-- ++ 1 col - icons -->
            <v-col cols="1" class="d-flex align-center px-0 justify-center">
                <v-row no-gutters>
                    <v-col cols="6" class="align-center pa-0">
                        <v-icon v-if="validated" class="px-2 pt-1" color="primary">
                            $check_circle
                        </v-icon>
                    </v-col>
                    <v-col cols="6" class="align-center pa-0">
                        <v-btn-icon
                            :icon="expanded ? '$fa-chevron-up' : '$fa-chevron-down'"
                            @click="expanded = !expanded"
                            style="width: 40px"
                            color="secondary"
                            class="d-inline px-2"
                        />
                    </v-col>
                </v-row>
            </v-col>
        </v-row>

        <v-expand-transition>
            <div v-if="expanded" class="px-4 pb-4">
                <slot name="{{expandContent}}"></slot>
            </div>
        </v-expand-transition>
    </v-card>
</template>

<script lang="ts">
import { Component, Vue, toNative, Prop } from "vue-facing-decorator";
import { isNumber } from "lodash";

import AuditCardCols from "./AuditCardCols.vue";

@Component({
    components: {
        AuditCardCols,
    },
})
export class AuditCard extends Vue {
    @Prop({ type: Boolean }) readonly active!: Boolean;
    @Prop({ default: null }) cardCols: any;
    @Prop({ default: "expand-content" }) readonly expandContent: string;
    @Prop({ default: false }) validated: boolean;

    expanded: boolean = false;

    toggleExpand() {
        this.expanded = !this.expanded;
    }

    isNumber(value) {
        return isNumber(value);
    }

    // // //////// TO DO ///////////

    beforeMount() {
        debugger;
        // Simuler une opération asynchrone, puis émettre 'query-done'
        this.queryData();
    }

    async queryData() {
        debugger;
        const result = await this.fetchData();
        this.$emit("query-done", result);
        // this.$emit("query-done-N1", result);
    }

    async fetchData() {
        debugger;
        // Simuler une requête (retourner une promesse)
        return new Promise((resolve) =>
            setTimeout(() => resolve({ success: true, data: ["2023-11", "2023-12"] }), 1000),
        );
    }

    // // ///////////////////

    dynamicClass(cols, isNested = true, rowIndex, rowsLength, col) {
        let columnClass = "";

        if (col.props?.class) {
            columnClass += ` ${col.props.class}`;
        }

        columnClass += " ma-0";

        if (isNested) {
            columnClass += " px-2";
        } else {
            columnClass += " px-4";
        }

        if (
            cols.some(
                (col) =>
                    col.component === "v-tooltip" ||
                    col.component === "v-date-picker" ||
                    col.component === "v-select" ||
                    col.component === "v-text-field" ||
                    col.component === "v-checkbox",
            )
        ) {
            columnClass += " py-0";
        } else {
            if (rowsLength === 1) {
                columnClass += " py-4";
            } else if (rowIndex === 0) {
                // first
                columnClass += " pt-4 pb-2";
            } else if (rowIndex === rowsLength - 1) {
                columnClass += " pt-2 pb-4";
            } else {
                columnClass += " py-2";
            }
        }

        return columnClass;
    }
}
export default toNative(AuditCard);
</script>

<style scoped>
/* Ajouter des styles spécifiques si nécessaire */
</style>
